module.exports = {
  '/api/internal/results': {
    data: {
      token: 'jwt-canonical-token',
      result: {
        id: 'res_TEST01',
        version: 1785237838,
        start_at: '2026-07-28T11:24:04.689Z',
        end_at: null,
        survey_id: 'srv_TEST01',
        last_position: null,
        current_page_id: 'pg_TEST01',
        state: 'started',
        display_order: ['pg_TEST01'],
        participant: {
          id: 'pcp_TEST01',
          email: null,
          first_name: null,
          last_name: null,
        },
        answers: [],
      },
      conditions: [],
    },
    status: 200,
    statusText: 'OK',
    headers: {
      'content-type': 'application/json; charset=utf-8',
    },
  },
};
